var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m244.07 0.66797c14.016 3.1133 23.227 16.234 21.785 30.176l-0.52734 3.2305-3.8555 17.332c71.188-7.3789 120.93 28.43 141.89 103.01l1.8008 6.7969c15.078 60.316 68.41 90.789 168.84 90.789 18.984 0 32.129 18.332 26.859 35.934l-1.125 3.0977-84 196c-3.7578 8.7656-11.723 15.02-21.133 16.586-121.97 20.332-201.28-12.008-226.12-98.691l-1.6445-6.1367c-13.973-55.891-34.184-74.383-67.75-66.57l-45.754 205.86c-3.3516 15.094-18.309 24.613-33.406 21.258-14.016-3.1133-23.227-16.234-21.785-30.176l0.52734-3.2305 112-504c3.3516-15.094 18.309-24.613 33.406-21.258zm6.5898 109.12-2.2812 0.52734-36.438 163.99c51.383-0.95703 88.637 35.973 107.4 103.98l1.8203 6.9258c13.23 52.926 56.406 75.598 139.11 66.656l10.129-1.2617 61.91-144.48-3.5391-0.30469c-94.406-9.5977-154.9-50.895-176.11-124.27l-1.8203-6.7617c-14.418-57.672-44.301-77.238-100.17-65.004z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.75aadd354b3431fad8f749a78ffeaca3.svg";
export { ForwardRef as ReactComponent };